import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    imgSegmentRuns: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    anyUpdate: false,
    crowdGroupId: null,
    imgSegmentRunId: null,
    imgSegmentQuestions: [],
    imgSegmentQuestionCount: 0,
    imgSegmentQuestionPage: 1,
    imgSegmentQuestionPageSize: 5,
    imgSegmentQuestionPages: 0,
    imgSegmentQuestionSortField: 'created_at',
    imgSegmentQuestionSortOrder: 'asc',
    imgSegmentQuestionSearch: null,
    imgSegmentQuestionError: '',
    imgSegmentQuestionId: null,
    imgSegmentDatasets: [],
    imgSegmentDatasetCount: 0,
    imgSegmentDatasetPage: 1,
    imgSegmentDatasetPageSize: 5,
    imgSegmentDatasetPages: 0,
    imgSegmentDatasetSortField: 'task_seq',
    imgSegmentDatasetSortOrder: 'asc',
    imgSegmentDatasetSearch: null,
    imgSegmentDatasetError: '',
}

const receivedImgSegmentRunsData=(state, action)=>{
    const { imgSegmentRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        imgSegmentRuns: imgSegmentRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId,
        anyUpdate: false
    }
}

const getImgSegmentRunDataError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedImgSegmentQuestions=(state, action)=>{
    const { imgSegmentQuestions,imgSegmentRunId,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        imgSegmentRunId: imgSegmentRunId,
        imgSegmentQuestions: imgSegmentQuestions,
        imgSegmentQuestionCount: count,
        imgSegmentQuestionPage: page,
        imgSegmentQuestionPageSize: pageSize,
        imgSegmentQuestionPages: pages,
        imgSegmentQuestionSortField: sortField,
        imgSegmentQuestionSortOrder: sortOrder,
        imgSegmentQuestionSearch: search
    }
}

const getImgSegmentQuestionDataError=(state, action)=> {
    return {
        ...state,
        imgSegmentQuestionError: action.error
    }
}

const receivedImgSegmentDatasets=(state, action)=>{
    const { imgSegmentDatasets,imgSegmentQuestionId,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        imgSegmentQuestionId: imgSegmentQuestionId,
        imgSegmentDatasets: imgSegmentDatasets,
        imgSegmentDatasetCount: count,
        imgSegmentDatasetPage: page,
        imgSegmentDatasetPageSize: pageSize,
        imgSegmentDatasetPages: pages,
        imgSegmentDatasetSortField: sortField,
        imgSegmentDatasetSortOrder: sortOrder,
        imgSegmentDatasetSearch: search
    }
}

const getImgSegmentDatasetDataError=(state, action)=> {
    return {
        ...state,
        imgSegmentDatasetError: action.error
    }
}

const triggerImgSegmentInstantResult=(state)=>{
    return {
        ...state,
        anyUpdate: true
    }
}

const triggerImgSegmentInstantResultError=(state, action)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_IMG_SEGMENT_RUN_DATA]: receivedImgSegmentRunsData,
    [actionTypes.GET_IMG_SEGMENT_RUN_DATA_ERROR]: getImgSegmentRunDataError,
    [actionTypes.GET_IMG_SEGMENT_QUESTION_DATA]: receivedImgSegmentQuestions,
    [actionTypes.GET_IMG_SEGMENT_QUESTION_DATA_ERROR]: getImgSegmentQuestionDataError,
    [actionTypes.GET_IMG_SEGMENT_DATASET_DATA]: receivedImgSegmentDatasets,
    [actionTypes.GET_IMG_SEGMENT_DATASET_DATA_ERROR]: getImgSegmentDatasetDataError,
    [actionTypes.TRIGGER_IMG_SEGMENT_INSTANT_RESULT]: triggerImgSegmentInstantResult,
    [actionTypes.TRIGGER_IMG_SEGMENT_INSTANT_RESULT_ERROR]: triggerImgSegmentInstantResultError
});


// WEBPACK FOOTER //
// ./src/redux/imgSegment/reducer.js